export enum HttpCode {
    BAD_REQUEST = 400,
    FORBIDDEN = 403,
    NOT_FOUND = 404,
    NO_CONTENT = 204,
    SERVER_ERROR = 500,
    UNAUTHORIZED = 401
}
